module.exports = __webpack_public_path__ + "static/img/favicon.637faa08.svg";